import _objectWithoutProperties from "D:\\a\\1\\s\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
import _extends from "@babel/runtime-corejs3/helpers/extends";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import React, { useContext, useState, useCallback, useMemo } from 'react';
import cx from 'classnames';
import { IntlContext } from '@jutro/locale';
import { getDecimalRegex, isSafeNumber } from '@jutro/data';
import { IconButton } from '../../IconButton/IconButton';
import styles from "./NumberInput.module.css";
export const NumberInput = _ref => {
  let value = _ref.value,
    onChange = _ref.onChange,
    onFocus = _ref.onFocus,
    onBlur = _ref.onBlur,
    decimalPlaces = _ref.decimalPlaces,
    disabled = _ref.disabled,
    restProps = _objectWithoutProperties(_ref, ["value", "onChange", "onFocus", "onBlur", "decimalPlaces", "disabled"]);
  const _useContext = useContext(IntlContext),
    formatNumber = _useContext.formatNumber;
  const _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    isFocused = _useState2[0],
    setFocused = _useState2[1];
  const numericValue = Number(value) || 0;
  const step = Number(restProps.step);
  const handleValueChange = useCallback(event => {
    var _event$target$value, _event$target;
    const newValue = (_event$target$value = (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value) !== null && _event$target$value !== void 0 ? _event$target$value : '';
    if (isSafeNumber(newValue) && getDecimalRegex(decimalPlaces).test(newValue)) {
      onChange(newValue);
    }
  }, [decimalPlaces, onChange]);
  const handleUpArrowClick = useCallback(() => {
    if (disabled) {
      return;
    }
    const newValue = numericValue + step;
    if (restProps.max === undefined || newValue <= restProps.max) {
      onChange(newValue);
    }
  }, [numericValue, step]);
  const handleDownArrowClick = useCallback(() => {
    if (disabled) {
      return;
    }
    const newValue = numericValue - step;
    if (restProps.min === undefined || newValue >= restProps.min) {
      onChange(newValue);
    }
  }, [numericValue, step]);
  const handleOnArrowMouseDown = useCallback(event => {
    event.preventDefault();
  }, []);
  const handleBlur = useCallback(event => {
    setFocused(false);
    onBlur(event);
  }, [onBlur]);
  const handleFocus = useCallback(event => {
    onFocus(event);
    setFocused(true);
  }, [onFocus]);
  const handleBeforeInput = useCallback(event => {
    const data = event.data;
    if (!data.match(/^[0-9,-. ]+$/)) {
      event.preventDefault();
    }
  }, []);
  const formattedValue = useMemo(() => !value && value !== 0 ? '' : formatNumber(value, {
    maximumFractionDigits: decimalPlaces
  }), [decimalPlaces, formatNumber, value]);
  return React.createElement("div", {
    className: styles.numberInput
  }, React.createElement("input", _extends({
    inputMode: "decimal",
    type: isFocused ? 'number' : 'text',
    value: isFocused ? value : formattedValue,
    onChange: handleValueChange,
    onBlur: handleBlur,
    onBeforeInput: handleBeforeInput,
    onFocus: handleFocus,
    disabled: disabled
  }, restProps)), isFocused && React.createElement(React.Fragment, null, React.createElement(IconButton, {
    icon: "mi-arrow-drop-up",
    onMouseDown: handleOnArrowMouseDown,
    onClick: handleUpArrowClick,
    className: cx(styles.numberInputButton, styles.numberInputUp),
    tabIndex: -1
  }), React.createElement(IconButton, {
    icon: "mi-arrow-drop-down",
    onMouseDown: handleOnArrowMouseDown,
    onClick: handleDownArrowClick,
    className: cx(styles.numberInputButton, styles.numberInputDown),
    tabIndex: -1
  })));
};
NumberInput.__docgenInfo = {
  componentName: "NumberInput",
  packageName: "@jutro/components",
  description: "",
  displayName: "NumberInput",
  methods: [],
  actualName: "NumberInput"
};